import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Gnb from '../components/gnb/Gnb';
import classes from './Layout.module.css';

const LayoutPage = () => {
 

  return (
    <div className={classes['wrapper']}>
      <Gnb />
      <div className={classes['contents']}>
        <Outlet />
      </div>
    </div>
  );
};

export default LayoutPage;